module.exports = __webpack_public_path__ + "static/media/mm.386487d6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mm.svg
// module id = 714
// module chunks = 0